import './footer.scss'
import { WWW_BASE, SUPPORT_EMAIL } from 'consts'

export default class Footer extends React.Component {
  static contextTypes = {
    muiTheme: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    return (
      <div>
        <div className='footer--standard'>
          <hr/>
          <p>
            Plug in Useful Copyright { new Date().getFullYear() }, All Rights Reserved
          </p>
          <p className="small-spacing--top medium-spacing--bottom body2">
            <a className="footer--standard__link" href={`${WWW_BASE}/terms`}>Terms & Conditions</a>
            <a className="footer--standard__link" href={`${WWW_BASE}/privacy`}>Privacy Policy</a>
            <a className="footer--standard__link" href={`${WWW_BASE}/eula`}>EULA</a>
            <a className="footer--standard__link" target="_blank" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/header/Footer.js